import  { useEffect } from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from './Button';
import FormInput from './FormInput';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import i18n from '../common/config/i18n';
import { CompanyStatus, ICompany, ICompanyDTO } from '../common/interfaces/company.interface';
import Toggle from './Toggle';

interface CompanyModalProps {
    title: string;
    onClose: () => void;
    onSubmit: (company: ICompanyDTO) => void;
    buttonLabel: string;
    company?: ICompany | null;
}

const schema = yup
    .object({
        name: yup.string().required(i18n.t('company_modal:name.errors.required')),
        contact: yup.string().notRequired()
    })
    .required();

const CompanyModal = ({ title, onClose, onSubmit, buttonLabel, company }: CompanyModalProps) => {
    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
    } = useForm<any>({
        mode: 'onChange',
        reValidateMode: 'onChange',
        resolver: yupResolver(schema),
    });

    const { t } = useTranslation('company_modal');

    useEffect(() => {
        if (company) {
            reset({ ...company, status: company.status === CompanyStatus.ACTIVE ? true : false, })
        }
    }, [company])


    return (
        <Modal title={title} onClose={onClose}>
            <div className="flex flex-col px-12 w-full gap-[60px]">
                <form className="gap-4" onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        key="name"
                        name="name"
                        control={control}
                        render={({ field: { onChange, value } }) => {
                            return (
                                <FormInput
                                    type="text"
                                    errorMessage={errors.name?.message?.toString()}
                                    value={value}
                                    label={t('name.label')}
                                    onChange={onChange}
                                    helper={t('name.helper')}
                                />
                            );
                        }}
                    />
                    <Controller
                        key="contact"
                        name="contact"
                        control={control}
                        render={({ field: { onChange, value } }) => {
                            return (
                                <FormInput
                                    type="text"
                                    errorMessage={errors.contact?.message?.toString()}
                                    value={value}
                                    label={t('contact.label')}
                                    onChange={onChange}
                                    helper={t('contact.helper')}
                                />
                            );
                        }}
                    />
                    {company && <Controller
                        key="status"
                        name="status"
                        control={control}
                        render={({ field: { onChange, value } }) => {
                            return (
                                <Toggle
                                    id="company_status__toggle"
                                    label={t('status.label')}
                                    enabledText={t('status.active')}
                                    disabledText={t('status.inactive')}
                                    onChange={onChange}
                                    value={value}
                                />
                            );
                        }}
                    />}

                </form>
                <div className="flex flex-row-reverse">
                    <Button
                        id="project_form__submit-button"
                        label={buttonLabel}
                        className="btn-primary w-full"
                        onClick={handleSubmit(onSubmit)}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default CompanyModal;
